import { SearchType } from '@mews-commander/enums';
import { type as typeUtil } from '@mews/framework';

export function SearchResult({
    title = '',
    description = '',
    url = null,
    searchType = null,
    id = null,
    options = {},
}: {
    title?: string;
    description?: string;
    url?: string | null;
    searchType?: SearchType | null;
    id?: string | null;
    options?: {};
} = {}) {
    return typeUtil.create(SearchResult, {
        title,
        description,
        url,
        searchType,
        id,
        options,
    });
}
